var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverLicenseBarcodeMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 64,
    viewBox: "0 0 104 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 103,
    height: 63,
    rx: 4.7,
    fill: "white",
    fillOpacity: 0.3,
    stroke: "#E6E7E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 10.1086,
    width: 104,
    height: 14.4431,
    fill: "#F8F8F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.592,
    y: 38.5427,
    width: 67.8476,
    height: 18.7208,
    rx: 0.990476,
    stroke: "#FFCE44",
    strokeWidth: 1.98095
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 71.5367,
    y1: 41.8799,
    x2: 71.5367,
    y2: 53.4343,
    stroke: "white",
    strokeWidth: 0.495238
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 73.1827,
    y1: 41.8799,
    x2: 73.1827,
    y2: 53.4343,
    stroke: "white",
    strokeWidth: 0.990476
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 75.0764,
    y1: 41.8799,
    x2: 75.0764,
    y2: 53.4343,
    stroke: "white",
    strokeWidth: 1.98095
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 77.1304,
    y1: 41.8799,
    x2: 77.1304,
    y2: 53.4343,
    stroke: "white",
    strokeWidth: 0.495238
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 79.2717,
    y1: 41.8799,
    x2: 79.2717,
    y2: 53.4343,
    stroke: "white",
    strokeWidth: 1.98095
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.247619,
    x2: 11.5545,
    y2: -0.247619,
    transform: "matrix(0 1 1 0 28.5312 41.8799)",
    stroke: "white",
    strokeWidth: 0.495238
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -0.495238,
    x2: 11.5545,
    y2: -0.495238,
    transform: "matrix(0 1 1 0 27.1328 41.8799)",
    stroke: "white",
    strokeWidth: 0.990476
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -0.990476,
    x2: 11.5545,
    y2: -0.990476,
    transform: "matrix(0 1 1 0 25.7344 41.8799)",
    stroke: "white",
    strokeWidth: 1.98095
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: -0.247619,
    x2: 11.5545,
    y2: -0.247619,
    transform: "matrix(0 1 1 0 22.9375 41.8799)",
    stroke: "white",
    strokeWidth: 0.495238
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    y1: -0.990476,
    x2: 11.5545,
    y2: -0.990476,
    transform: "matrix(0 1 1 0 21.5391 41.8799)",
    stroke: "white",
    strokeWidth: 1.98095
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.584 43.3628V44.5161H56.5381V45.0181H55.291V43.3628H55.584Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4912 42.2083V42.7014H56.2441V42.2083H57.4912Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4902 45.6792V46.8325H58.4443V47.3257H57.1973V45.6792H57.4902Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6777 43.3628V45.0181H53.3779V43.856H52.4238V43.3628H53.6777Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6318 42.2083V42.7024H54.3379V42.2083H54.6318Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8105 44.5171V45.6792H51.7646V46.1724H50.8105V47.3257H50.5176V44.5171H50.8105Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.585 46.8298V47.324H55.291V46.8298H55.585Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2959 43.3628V43.8569H61.002V43.3628H61.2959Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3965 44.5171V46.1724H59.1035V44.5171H59.3965Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6777 46.8298V47.323H52.4238V46.8298H53.6777Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6318 45.6753V46.1694H54.3379V45.6753H54.6318Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3037 42.2083V42.7024H60.0098V42.2083H60.3037Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4521 43.3665V43.8606H58.1582V43.3665H58.4521Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7646 42.2083V42.7014H50.5176V42.2083H51.7646Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1338 46.7993V47.2856H62.8926V46.7993H64.1338Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0381 46.7993V47.2866H61.3262V46.7993H61.0381Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9834 45.6526V46.1399H62.2715V45.6526H61.9834Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1182 44.502V44.9893H64.8301V44.502H65.1182Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0625 42.2083V43.8401H65.7754V42.2083H66.0625Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9619 44.502V44.9961H67.0146V46.1426H66.7207V44.502H67.9619Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8369 46.7993V47.2866H69.5488V46.7993H69.8369Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0635 46.7993V47.2866H65.7754V46.7993H66.0635Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8916 45.6526V46.1399H68.6035V45.6526H68.8916Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8594 43.3552V44.9958H69.5723V43.3552H69.8594Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9082 42.2083V42.6946H67.6738V42.2083H68.9082Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2676 44.5059V44.9922H61.0332V44.5059H62.2676Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.127 42.2083V42.6946H63.1797V43.8489H62.8926V42.2083H64.127Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8965 43.3628V44.5161H35.8506V45.0181H34.6035V43.3628H34.8965Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8037 42.2083V42.7014H35.5566V42.2083H36.8037Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8027 45.6792V46.8325H37.7568V47.3257H36.5098V45.6792H36.8027Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9902 43.3628V45.0181H32.6904V43.856H31.7363V43.3628H32.9902Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9443 42.2083V42.7024H33.6504V42.2083H33.9443Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.123 44.5171V45.6792H31.0771V46.1724H30.123V47.3257H29.8301V44.5171H30.123Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8975 46.8298V47.324H34.6035V46.8298H34.8975Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6084 43.3628V43.8569H40.3145V43.3628H40.6084Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M38.709 44.5171V46.1724H38.416V44.5171H38.709Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.660318
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverLicenseBarcodeMobile);
export default __webpack_public_path__ + "static/media/driver-license-barcode-mobile.6ddc5701d9f4663c8cc478918f80cb60.svg";
export { ForwardRef as ReactComponent };